import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import config from '../store/_config';
import { buildElasticGraphQLParams } from "../selectors/converterSelector";

export const axiosRequestDispatchList = (listParams) => {
    let { url, query } = config.dispatch.dispatchList;

    let params = buildElasticGraphQLParams(listParams);

    query = query.replace(/{params}/, params);
    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosSubmitManifest = () => {
    let { url, query } = config.dispatch.submitManifest;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosPackOrder = (id = 0) => {
    let { url, query } = config.dispatch.packOrder;
    query = query.replace('{ID}', id);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosUnpackOrder = (id = 0) => {
    let { url, query } = config.dispatch.unpackOrder;
    query = query.replace('{ID}', id);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosAwaitingPickupOrder = (id = 0) => {
    let { url, query } = config.dispatch.awaitingPickupOrder;
    query = query.replace('{ID}', id);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosRequestManifestList = (listParams) => {
    let { url, query } = config.dispatch.manifestList;

    let params = buildElasticGraphQLParams(listParams);

    query = query.replace(/{params}/, params);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosPrintManifest = (id = 0) => {
    let { url, query } = config.dispatch.printManifest;
    query = query.replace('{ID}', id);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosUnprintManifest = (id = 0) => {
    let { url, query } = config.dispatch.unprintManifest;
    query = query.replace('{ID}', id);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosRequestDispatchHistoryList = (listParams) => {
    let { url, query } = config.dispatch.dispatchHistory;

    let params = buildElasticGraphQLParams({
        ...listParams,
        filters: {
            ...listParams.filters,
            ManifestedOnly: true,
        }
    });

    listParams.filters.ManifestedOnly = true;

    query = query.replace(/{params}/, params);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
